module.exports = __webpack_public_path__ + "img/dd3137d.svg";